import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-box-input',
  templateUrl: './box-input.component.html',
  styleUrls: ['./box-input.component.scss']
})
export class BoxInputComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
